import page from "./_Layout/_Layout";

import { Feature } from "features/interfaces";

export const layoutFeature: Feature = {
  page
};
